import axios from 'axios';
const { NProgress } = window;

const thenSuccess = (value) => {
    NProgress.done();
    return value;
}

const thenError = (error) => {
    NProgress.done();
    throw error;
}

class Api {
    
    get(url, config = {}) {
        NProgress.start();

        return axios({
            method: 'get',
            url: this.url(url),
        }).then(thenSuccess, thenError);
    }
    
    post(url, params = {}) {
        NProgress.start();
        
        return axios.post(this.url(url), params).then(thenSuccess, thenError);
    }

    request(config) {
        NProgress.start();
        
        if (config.url) {
            config.url = this.url(config.url);
        }
        
        return axios(config).then(thenSuccess, thenError);
    }

    url(path) {
        if (process.env.NODE_ENV === 'development') {
            return 'http://localhost/clients/spark44/aventura-increible/backend/' + (path ? path : '');
        } else {
            return 'https://www.infolandrover.es/aventuraincreible/backend/' + (path ? path : '');
        }
    }
    publicUrl() {
        if (process.env.NODE_ENV === 'development') {
            return 'http://aventuraincreible.localhost:3000/';
        } else {
            return 'https://www.infolandrover.es/aventuraincreible/map/';
        }
    }

}

export default new Api();


// WEBPACK FOOTER //
// ./src/Api.js